import type { FC, ReactElement } from "react"

type _TLockProps = { className: string }

const LockIcon: FC<_TLockProps> = ({ className }: _TLockProps): ReactElement => (
    <svg
        className={className}
        width="11"
        height="15"
        viewBox="0 0 11 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.64704 5.5588V3.11367C8.64704 1.39402 7.12653 0 5.25 0C3.37385 0 1.85296 1.39538 1.85296 3.11367V5.5588H1.1638C0.52107 5.5588 2.67029e-05 6.11285 2.67029e-05 6.79312V12.9715C2.67029e-05 13.6533 0.520724 14.2059 1.1638 14.2059H9.33622C9.97896 14.2059 10.5 13.6518 10.5 12.9715V6.79312C10.5 6.11139 9.9793 5.5588 9.33622 5.5588H8.64704ZM9 7.10289V12.7279H1.5V7.10289H9ZM3.375 5.5588V3.11367C3.375 2.10223 4.03382 1.47789 5.25 1.47789C6.46701 1.47789 7.125 2.10129 7.125 3.11367V5.5588H3.375ZM5.86764 9.1315C5.86764 8.79045 5.59352 8.51395 5.25 8.51395C4.9089 8.51395 4.63236 8.78804 4.63236 9.1315V10.9847C4.63236 11.3257 4.90648 11.6022 5.25 11.6022C5.5911 11.6022 5.86764 11.3281 5.86764 10.9847V9.1315Z"
            fill="#B4B4EF"
        />
    </svg>
)

export default { LockIcon }
